import React from 'react';
import { FaseCategoriaTorneio } from '../../../services/categoriaTorneioService';
import { formatISODate } from '../../../utils/date';

export interface PhaseRowProps {
  phase: FaseCategoriaTorneio;
  onEdit: (phase: FaseCategoriaTorneio) => void;
  onDelete: (phase: FaseCategoriaTorneio) => void;
  onDragStart: (id: string) => void;
  onDragOver: (id: string) => void;
  onDrop: () => void;
}

const PhaseRow: React.FC<PhaseRowProps> = ({ phase, onEdit, onDelete, onDragStart, onDragOver, onDrop }) => {
  return (
    <tr
      draggable
      onDragStart={() => onDragStart(phase.id)}
      onDragOver={(e) => {
        e.preventDefault();
        onDragOver(phase.id);
      }}
      onDrop={onDrop}
    >
      <td>
        <button type="button" className="btn btn-link p-0" onClick={() => onEdit(phase)}>
          {phase.nome}
        </button>
      </td>
      <td>
        {formatISODate(phase.dataInicio)} - {formatISODate(phase.dataFim)}
      </td>
      <td>{phase.status}</td>
      <td>{phase.ordem}</td>
      <td>
        <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => onEdit(phase)}>
          Editar
        </button>
        <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(phase)}>
          Excluir
        </button>
      </td>
    </tr>
  );
};

export default PhaseRow;
